import dao from '../../common/DataAccessUtil';
import configurationService from '../core/configuration.service';
import appConfig from '../../config.json';
const ControllerName = 'ArtworkItem';
export interface IArtworkGridRowItem {
  Id: number;
  EventTitle: string;
  ArtTitle: string;
  MediaName: string;
  ReleaseDate: any;
  CreatedDate: any;
  EventSectionTitle: string;
  ArtTemplateTitle: string;
  SpecialPrize: boolean;
  ArtUrl: string;
  ArtOwner: string;
  IsEventActive: any;
}
export interface IArtworkItemG {
  Id: number;

  ArtTitle: string;
  MediaName: string;
  ReleaseDate: any;
  EventSectionId: string;
  EventSectionTitle: string;
  ArtTemplateId: string;
  ArtTemplateTitle: string;
  SpecialPrize: boolean;
  ArtUrl: string;
}
export default {
  create: async (
    eventId: number,
    artTitle: string,
    mediaName: string,
    releaseDate: any,
    eventSectionId: number,
    artTemplateId: number,
    artUrl: string,
    specialPrize: boolean,
    fileIds: number[],
  ) => {
    const body = {
      EventId: eventId,
      Title: artTitle,
      MediaName: mediaName,
      ReleaseDate: releaseDate,
      EventSection: eventSectionId,
      ArtTemplate: artTemplateId,
      ArtUrl: artUrl,
      SpecialPrize: specialPrize,
      FileIds: fileIds,
    };
    return dao.postJsonData(configurationService.getApiConfig(), ControllerName, body);
  },
  update: async (
    id: number,
    artTitle: string,
    mediaName: string,
    releaseDate: any,
    eventSectionId: number,
    artTemplateId: number,
    artUrl: string,
    specialPrize: boolean,
    fileIds: number[],
  ) => {
    const body = {
      Id: id,
      Title: artTitle,
      MediaName: mediaName,
      ReleaseDate: releaseDate,
      EventSection: eventSectionId,
      ArtTemplate: artTemplateId,
      ArtUrl: artUrl,
      SpecialPrize: specialPrize,
      FileIds: fileIds,
    };
    return dao.postJsonData(configurationService.getApiConfig(), ControllerName + '/update', body);
  },
  search: async (eventId: number, title: string, pageNumber: number, pageSize: number) => {
    const body = { Filter: title, Sort: 'Id desc', PageNumber: pageNumber, PageSize: pageSize };
    return dao.postJsonData(configurationService.getApiConfig(), ControllerName + '/searchEventArtworks', body);
  },
  getExcel: async (title: string, pageNumber: number, pageSize: number) => {
    if (pageSize > appConfig.MaxPageSize) pageSize = appConfig.MaxPageSize;
    const body = { Filter: title, Sort: 'Id desc', PageNumber: pageNumber, PageSize: pageSize };
    return dao.postJsonData(configurationService.getApiConfig(), ControllerName + '/excel', body);
  },
  getAll: async () => {
    const body = { Filter: '', Sort: 'Id desc', PageNumber: 1, PageSize: 200 };
    return dao.postJsonData(configurationService.getApiConfig(), ControllerName + '/searchEventArtworks', body);
  },
  myArtworks: async () => {
    const body = { Filter: '', Sort: 'Id desc', PageNumber: 1, PageSize: appConfig.MaxPageSize };
    return dao.postJsonData(configurationService.getApiConfig(), ControllerName + '/myArtworks', body);
  },
  export: async (title: string) => {
    const body = { Filter: title, Sort: 'Id desc', PageNumber: 1, PageSize: 10000 };
    return dao.postJsonData(configurationService.getApiConfig(), ControllerName + '/export', body);
  },
  getById: async (itemId: number) => {
    return dao.getJsonData(configurationService.getApiConfig(), ControllerName + '/' + itemId);
  },
  deleteFile: async (fileId: string) => {
    return dao.postJsonData(configurationService.getApiConfig(), ControllerName + '/deletefile', {
      FileGuid: fileId.toString(),
    });
  },
  uploadfile: async (selectedFile: any) => {
    return dao.UploadFile(configurationService.getApiConfig(), ControllerName + '/uploadfile', selectedFile);
  },
  delete: async (id: number) => {
    return dao.postJsonData(configurationService.getApiConfig(), ControllerName + '/delete', { Id: id });
  },
};
